import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

import SidePanelContainer from '../../panels/sidePanel/sidePanel-transition'
import {pickerPages, printPage} from '../module-actions'


import List from '../../list/list'
import ListExpandable from '../../list/list-expandable'
import Text from '../../form/form-text'
import Select from '../../form/form-select'
import Radios from '../../form/form-radios'
import Button from '../../button/button'

import '../module.styl'
class ModuleListVideosMeta extends React.Component {
    static SIDE_PANEL_ID = 0;

    constructor(props){
        super(props)
        this.sidePanelId = "sidePanel-module-listVideosMeta-" + (ModuleListVideosMeta.SIDE_PANEL_ID++)
        this.i18n = 'app.modules.'
        this.state = {
            data: Object.assign({}, this.props),
            disabled: this.props.disabled
        }
        !this.state.data.link && (this.state.data.link = {})

        let positions = [];
        ["Frame", "Top", "Bottom"].forEach(position => [1,2,3].forEach(num => positions.push(position + num))  );
        this.temp = {
            types: ["Web", "Tablette", "Mobile"].map(t => ({id: t, value: t})),
            pubPositions: positions.map( t => ({id: t, value: t}) ),
            linkTypes: ["internalLink", "url", "default"].map( (t, i) => ({id: t + '_' + i, name: t, value: t}))
        }
        this.selectPage = this.selectPage.bind(this)
        this.devicesTemplate = this.devicesTemplate.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    devicesTemplate(device) {
        let { disabled } = this.state;
        return <div className="module-pub-devices">
            <Select disabled={disabled} value={device.type} options={this.temp.types} />
            <Text disabled={disabled} value={device.width} />
            <Text disabled={disabled} value={device.height} />
        </div>
    }

    selectPage(pages){
        if (!pages.length) {
            return;
        }
        let page = pages[0];
        this.state.data.link.value = page.id
        this.state.page = page;
        this.setState(this.state);
    }

    render() {
        let { pub={}, title, button={} } = this.state.data;
        let { devices=[] } = pub;
        let { disabled, page=false } = this.state;

        console.log('ModuleListVideosMeta', this.state)
        console.log('ModuleListVideosMeta', this.props)

        return <div className="module-listVideosMeta">
            <Text disabled={disabled} value={title} label="app.title"/>
            <Select disabled={disabled} value={pub.position} options={this.temp.pubPositions} label={this.i18n + "pub"} />
            <div className="module-pub-devices">
                <div className="select"> <FormattedMessage id='app.type'/></div>
                <div className="input"> <FormattedMessage id='app.width'/></div>
                <div className="input"> <FormattedMessage id='app.height'/></div>
            </div>

            { !disabled && <ListExpandable collection={devices} template={ this.devicesTemplate } /> }
            <List printable={!disabled} collection={devices.map(this.devicesTemplate)} />

            <div className="module-listVideosMeta-link">
                <label><FormattedMessage id={this.i18n + 'hookLink'} /></label>
                <Text disabled={disabled} value={button.name} onChange={v => button.name = v} label={this.i18n + "hookLink.name"}/>
                <Radios disabled={disabled} value={button.type} onChange={elt => {
                    console.log(elt)
                    this.state.data.button.type = elt.value
                    this.setState(this.state)
                    return Promise.resolve(elt.value)
                }} label={this.i18n + "hookLink.type"} options={this.temp.linkTypes} />

                {button.type === 'internalLink' && <div>
                    <Button label={this.i18n + "btn.picker." + (page ? "changePage" : "selectPage")} onClick={e => pickerPages(this.sidePanelId, this.selectPage)} />
                    {page && printPage(page)}
                </div>}
                {button.type === 'url' && <Text disabled={disabled} value={button.value} onChange={v => this.state.data.button.value = v} placeholder={this.i18n + "hookLink.url"}/>}
                {button.type === 'default' && <Text disabled={disabled} value={button.value} onChange={v => this.state.data.button.value = v} placeholder={this.i18n + "hookLink.url"}/>}
            </div>

            <SidePanelContainer id={this.sidePanelId} />
        </div>
    }
}

ModuleListVideosMeta.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,
    title: PropTypes.string,
    pubs: PropTypes.array,

    orderBy: PropTypes.string,
    count: PropTypes.number,
    appsOnly: PropTypes.bool
}

export default ModuleListVideosMeta;

